import {
    buildCareRouteUrl,
    buildCareUrl,
    getCareBaseUrl,
} from '@/services/careUrls';

export const CARE_ACCOUNT_URLS = {
    manageAccount: buildCareRouteUrl('manageAccount'),
    billing: buildCareRouteUrl('billing'),
    makePayment: buildCareRouteUrl('makePayment'),
    refreshRadioUnauth: buildCareRouteUrl('refreshRadio'),
    transferSubscription: buildCareRouteUrl('transferSubscription'),
} as const;

// Always use the same refresh-signal path. Append the receiver only when a
// Radio ID is available.
export function buildRefreshRadioUrl(radioId: string | undefined): string {
    return buildCareRouteUrl('refreshSignal', {
        queryParams: {
            receiver: radioId?.trim(),
        },
    });
}

export { buildCareRouteUrl, buildCareUrl, getCareBaseUrl };
